import axiosInstance from './axiosCreator';
import {
  InstitutionalClaimOptions,
  InstitutionalClaimResult,
} from '../types/InstitutionalAccess';

export const getInstitutionalClaimOptions =
  async (): Promise<InstitutionalClaimOptions | null> => {
    try {
      const response = await axiosInstance.get<InstitutionalClaimOptions>(
        '/institutional-access/claim-options'
      );

      return response.data;
    } catch (error) {
      console.error('Error fetching institutional claim options:', error);
      return null;
    }
  };

export const claimInstitutionalAccess =
  async (): Promise<InstitutionalClaimResult | null> => {
    try {
      const response = await axiosInstance.post<InstitutionalClaimResult>(
        '/institutional-access/claim'
      );

      return response.data;
    } catch (error) {
      console.error('Error claiming institutional access:', error);
      return null;
    }
  };
